import { ControlSettingsSectionModel } from "./control-settings-section.model";
import { SettingsPropertyModel } from "./settings-property.model";

export class ControlSettingsModel {

    Section:ControlSettingsSectionModel;
    Properties:SettingsPropertyModel[];

    constructor(section:ControlSettingsSectionModel, properties: SettingsPropertyModel[]){
        this.Section = section;
        this.Properties = properties;
    }

    public static map(model:any):ControlSettingsModel{

        var section:ControlSettingsSectionModel = ControlSettingsSectionModel.map(model.Section);
        var properties:SettingsPropertyModel[] = [];
        model.Properties.forEach(c => {
            let sp = SettingsPropertyModel.map(c);
            properties.push(sp);
        });

        return new ControlSettingsModel(section, properties);
    }
}
